<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="d-flex flex-row justify-content-between">
        <div>
          <h2 class="page-title">User Management - User Settings</h2>
        </div>
        <div class="d-flex flex-row justify-content-end">
          <div class="mr-3">
            <router-link
              to="/dashboard/settings/user-management/restore-user"
              style="color: white; text-decoration: none"
            >
              <button
                class="btn"
                type="button"
                style="
                  background-color: #f36f21;
                  color: white;
                  margin: 0;
                  width: 100%;
                  font-weight: bold;
                  font-family: proxima-nova, sans-serif;
                "
              >
                Restore User
              </button>
            </router-link>
          </div>
          <div class="mr-3">
            <button
              class="btn"
              type="button"
              style="
                background-color: #f36f21;
                color: white;
                margin: 0;
                width: 100%;
                font-weight: bold;
                font-family: proxima-nova, sans-serif;
              "
              @click="openCreateUserModal"
            >
              Create User
            </button>
          </div>
          <a href="" class="btn" style="    margin-right: -1rem !important;
    padding: 0;">
            <img src="@/assets/img/notification.svg" alt="" style="display: none;">
          </a>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <div class="bg-white shadow box-content mt-5">
      <div style="display: flex; flex-direction: row; align-items: center">
        <h5
        style="
          font-size: 20px;
          color: #4d4d4d;
          font-weight: 600;
          font-family: proxima-nova, sans-serif;
        "
      >
        User List
      </h5>
      <div class="input-group mr-3">
        <div class="input-group-prepend">
          <span class="input-group-text bg-white">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <input
          class="form-control filterInput col-lg-2"
          type="search"
          placeholder="Search by Name"
          aria-label="Search"
          v-model="filter.name"
          @click="vue_universal_table.update++"
          style="border-left: 0; font-family: proxima-nova, sans-serif"
        />
      </div>
      </div>

      <vue-universal-table
        api_url="/api/user"
        :filter="filter"
        :buttons="vue_universal_table.buttons"
        :fields="vue_universal_table.fields"
        :update="vue_universal_table.update"
        :process_data="vue_universal_table.process_data"
        :table_striped="false"
        :indexing="true"
        :disable_limit_per_page="true"
        sort_order="DESC"
        sort_by="id"
        @onEdit="editUser"
        @onDelete="deleteUser"
      ></vue-universal-table>
    </div>

    <cu-user-management
      v-if="modal.new || modal.edit"
      :data="modal.edit ? modal.editData : null"
      api_new="/api/user"
      :api_edit="modal.edit ? `/api/user/${modal.editData.id}` : ''"
      form_type="User"
      :is_company_exist="false"
      @refreshData="vue_universal_table.update++"
      @closeModal="
        modal.new = false;
        modal.edit = false;
      "
    ></cu-user-management>
  </div>
</template>

<script>
import cuUserManagement from "./children/CUUserManagement";

export default {
  metaInfo: {
    title: "User Settings",
  },
  data() {
    return {
      modal: {
        new: false,
        edit: false,
        editData: false,
      },

      filter: {
        search: "",
      },
      vue_universal_table: {
        buttons: [
          {
            title: "Edit",
            variable: null,
            class: "fas fa-edit  btn-secondary rounded-button float-right",
          },
          {
            title: "Delete",
            variable: "id",
            class: "fas fa-trash  btn-secondary rounded-button",
          },
        ],
        fields: [
          { title: "User/Ekspedisi", variable: "username", disable_sort: true },
          { title: "Role", variable: "type", disable_sort: true },
          { title: "Date Created", variable: "created_at", disable_sort: true },
          { title: "Status", variable: "status", disable_sort: true },
        ],
        update: 0,
        process_data: `
					for (var i in data) {
					// Convert status
					data[i].status = data[i].status == 1 ? "Active" : "Inactive";

					// Convert date format to DD/MM/YYYY
					var createdAt = new Date(data[i].created_at);
					var day = createdAt.getDate().toString().padStart(2, '0');
					var month = (createdAt.getMonth() + 1).toString().padStart(2, '0');
					var year = createdAt.getFullYear().toString();
					data[i].created_at = day + '/' + month + '/' + year;
					}
				`,
      },
    };
  },
  components: {
    cuUserManagement,
  },
  mounted() {},
  watch: {
    filter: {
      deep: true,
      handler: function () {
        this.updateDebounceData();
      },
    },
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];
      this.vue_universal_table.update++;
      this.updateDebounceData();
    },
    "selected.dateButtonsIndex"() {
      // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
    },
  },
  methods: {
    openCreateUserModal() {
      this.modal.new = true;
    },
    editUser(user) {
      this.modal.editData = JSON.parse(user);
      this.modal.edit = true;
    },
    deleteUser(userId) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085D6",
          cancelButtonColor: "#D33",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel",
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .delete("/api/user/" + userId)
              .then(() => {
                this.$swal.fire({
                  title: "Success!",
                  icon: "success",
                  type: "success",
                  text: `User has been successfully deleted`,
                });
                // Fetch and update data after successful deletion
                this.vue_universal_table.update++;
              })
              .catch((err) => {
                console.log(
                  "%cerror DashboardUserUM.vue line:78 ",
                  "color: red; display: block; width: 100%;",
                  err
                );
                this.$swal.fire({
                  title: "Error!",
                  icon: "error",
                  type: "error",
                  text: err.response.data.message,
                });
              });
          }
        });
    },

    updateTableData() {
      // Manually incrementing the update prop to trigger an update
      this.vue_universal_table.update++;
    },
  },
};
</script>

<style scoped>
.box-content {
  padding: 20px;
  border-radius: 10px;
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}
</style>
